// Chakra imports
import {
	Accordion,
	AccordionButton,
	AccordionIcon,
	AccordionItem,
	AccordionPanel,
	Box,
	Flex,
	Image,
	Link,
	Text,
	useColorModeValue,
} from '@chakra-ui/react';
import Card from 'components/card/Card.js';

export default function WalletAccordion({ wallets = [], ...rest }) {
	const cardBg = useColorModeValue('gray.100', 'gray.500');
	const textColorPrimary = useColorModeValue('gray.900', 'gray.100');
	const textColorSecondary = useColorModeValue('gray.900', 'gray.100');

	return (
		<Card bg={cardBg} mb='20px' boxShadow='md' {...rest}>
			<Flex direction='column' mb='20px' ms='10px'>
				<Text fontSize='xl' color={textColorPrimary} fontWeight='bold' mb={2}>
					💳 Wallets
				</Text>
				<Text fontSize='md' color={textColorSecondary} mb={4}>
					¿Cuentas ya con una dirección lightning? Revisa estas carteras
					recomendadas:
				</Text>
			</Flex>
			<Accordion allowToggle>
				{wallets.map((wallet, index) => (
					<AccordionItem key={index} borderTopWidth='0px'>
						<h2>
							<AccordionButton
								_expanded={{ bg: 'brand.500', color: 'gray.100' }}
								borderRadius='16px'
							>
								<Flex align='center' flex='1' textAlign='left' gap={3} py={2}>
									{wallet.image && (
										<Box boxSize='60px' borderRadius='10%' overflow='hidden'>
											<Image
												src={wallet.image}
												alt={wallet.title}
												boxSize='100%'
												objectFit='cover'
												transform='scale(1.02)'
											/>
										</Box>
									)}
									<Text fontSize='md' fontWeight='bold'>
										{wallet.title}
									</Text>
								</Flex>
								<AccordionIcon />
							</AccordionButton>
						</h2>
						<AccordionPanel pb={4}>
							<Text mt={4} mb={8} color={textColorSecondary}>
								{wallet.description}
							</Text>
							{wallet.link && (
								<Link
									href={wallet.link}
									color='blue.400'
									isExternal
									fontWeight='bold'
									transition='transform 0.2s ease'
									_hover={{ transform: 'scale(1.05)' }}
								>
									Instalar →
								</Link>
							)}
						</AccordionPanel>
					</AccordionItem>
				))}
			</Accordion>
		</Card>
	);
}
